/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

import ErrorName from '../../error/error-name';

/**
 * Nahrazovač nastavení obrazovky zařízení
 *
 * Stará se o aktualizaci orientace zařízení dle obsahu datového skladu.
 */
class ReplacerScreen {
  /**
   * Vytvoří instanci.
   * @param {ScreenManager} screenManager
   * @param {Logger} logger
   */
  constructor(screenManager, logger) {
    this.screenManager = screenManager;
    this.logger = logger;
  }

  /**
   * Změní nastavení obrazovky dle obsahu.
   * @param {ContentInfo} contentInfo
   * @returns {Promise.<undefined>}
   */
  replace(contentInfo) {
    return new Promise((resolve) => {
      if (isNil(contentInfo.session.orientationEnum)) {
        return resolve();
      }
      return resolve(
        this.screenManager
          .setOrientation(contentInfo.session.orientationEnum)
          .catch((error) => {
            // Chyby vycházející z nepodpory operací se ignorují.
            if (error.name === ErrorName.NotSupportedError) {
              return this.logger.warn(error);
            }
            throw error;
          })
      );
    });
  }
}

export default ReplacerScreen;
